import type { Nullable } from '../../typescript'
import type { HasID } from './has_id'

export default function findByIdOrThrow<T extends HasID>(list: Array<T>, id: Nullable<HasID['id']>): T {
  if (id) {
    for (let index = 0; index < list.length; index++) {
      const item = list[index]
      if (item.id === id) {
        return item
      }
    }
  }
  throw new Error('missing row')
}
